import type { PopoverOrigin } from '@mui/material';

/**
 * The What's New popover's anchor/transform origins. Mirrors
 * `getPersonaMenuOrigins.ts`'s precedent exactly — extracted as a pure
 * function so the positioning is unit-testable without fighting MUI
 * Popper's DOM internals.
 *
 * Requirements (requirements-whats-new.md §4): the popover opens to the
 * RIGHT of the sidebar, bottom-aligned with the sidebar footer, growing
 * UPWARD over the dashboard content. In MUI Popover terms, that is the
 * anchor's bottom-right corner (`anchorOrigin`) meeting the paper's own
 * bottom-left corner (`transformOrigin`) — the paper then extends
 * rightward and upward from that single pinned point.
 *
 * Unlike `getPersonaMenuOrigins`, this takes no `collapsed` parameter: that
 * helper re-centers horizontally because its menu opens directly above a
 * trigger whose own width changes (full row vs. centered icon); this
 * popover always opens to the right of the sidebar's right edge regardless
 * of the trigger's internal layout, so the same fixed origins apply in
 * both sidebar states — a parameter with no effect on the result would
 * just be dead weight at every call site.
 */
export const getWhatsNewPopoverOrigins = (): {
  readonly anchorOrigin: PopoverOrigin;
  readonly transformOrigin: PopoverOrigin;
} => ({
  anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
  transformOrigin: { horizontal: 'left', vertical: 'bottom' },
});
